import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports/ads'),
      name: 'ads_reports',
      component: () => import('./pages/AdsReportsPage.vue'),
      meta: {
        permissions: ['administrator', 'meta_capi_manage'],
      },
    },
  ],
};
